export default __webpack_public_path__ + "static/media/gallery-img-6.01109d1f.jpg";